export default __webpack_public_path__ + "static/media/waiting.5f3ad6c9.svg";